import React from 'react';
import Emoji from './Emoji';
import styles from './EmojiCategory.module.scss';
import addTestId from '../../utils/addTestId';

interface EmojiCategoryProps {
  title: string;
  items: { emoji: { name: string; char: string }; tonedChar: string }[];
  onPick: (emoji: string) => void;
}

const EmojiCategory = ({ title, items, onPick }: EmojiCategoryProps) => (
  <>
    <h3 className={styles.title}>{title}</h3>
    <div className={styles.emojiList}>
      {items.map(({ emoji, tonedChar }) => (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited
        <div
          key={tonedChar}
          title={emoji.name}
          {...addTestId(`emoji_${emoji.name}`)}
          className={styles.emoji}
          onClick={() => onPick(tonedChar)}
        >
          <Emoji char={tonedChar} size="large" />
        </div>
      ))}
    </div>
  </>
);

export default EmojiCategory;
